import React, { Component } from "react";
import { Col, Row, message, Select, Table, Spin, Tooltip, Button } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { AuthHeader } from "../helper/auth.token";
import { monthMapping } from "../utils/const";
import querystring from "query-string";

import '../asset/style/dashboard.css';
import '../asset/style/add_case.css';

const { Option } = Select;

class StatsDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            selectedYear: new Date().getFullYear(),
            currentYear: new Date().getFullYear(),
            selectedMonth: new Date().getMonth(),
            fullStatsData: {},
        };
    }

    componentDidMount = () => {
        this.getStatsData();
    }

    getStatsData = () => {
        this.setState({
            isFetching: true,
        });

        let url = '/api/get_stats_data';
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                this.setState({
                    isFetching: false,
                });
                this.setState({
                    fullStatsData: response.data,
                });
                console.log(response.data)
            })
            .catch(err => {
                message.error("Failed to get stats. Contact Admin");
                console.log(err);
                this.setState({
                    isFetching: false,
                });
            });
    }

    getPlots = (key) => {
        this.setState({
            isFetching: true,
        });
        let x = this.state.fullStatsData[this.state.selectedYear][this.state.selectedMonth+1][key]['area']
        let y = this.state.fullStatsData[this.state.selectedYear][this.state.selectedMonth+1][key]['time']

        let url = '/api/get_time_plot/';
        axios.post(url, querystring.stringify({'x': x, 'y': y}), { headers: { Authorization: AuthHeader() } })
            .then(response => {
                this.setState({
                    isFetching: false,
                });
                // this.setState({
                //     fullStatsData: response.data,
                // });
                window.open("http://0.0.0.0"+response.data, '_blank', 'noopener,noreferrer');
                console.log(response.data)
            })
            .catch(err => {
                message.error("Failed to get stats. Contact Admin");
                console.log(err);
                this.setState({
                    isFetching: false,
                });
            });
    }

    handleChangeYear = (value) => {
        this.setState({
            selectedYear: value,
        });
    }

    getYearOptions = () => {
        let yearOptions = [];
        for(let i = 2018; i <= new Date().getFullYear(); i++) {
            yearOptions.push(
                <Option value={i}>{i}</Option>
            )
        }
        return yearOptions;
    }

    handleChangeMonth = (value) => {
        console.log(this.state.selectedMonth)
        this.setState({
            selectedMonth: value,
        });
        console.log(this.state.selectedMonth)
    }

    getMonthOptions = () => {
        let monthOptions = [];
        if(this.state.selectedYear != undefined && (this.state.currentYear != this.state.selectedYear)){
            for(let i = 1; i <= 13; i++) {
                monthOptions.push(
                    <Option value={i-1}>{monthMapping[i]}</Option>
                )
            }
            return monthOptions;
        }
        for(let i = 1; i <= new Date().getMonth() + 1; i++) {
            monthOptions.push(
                <Option value={i-1}>{monthMapping[i]}</Option>
            )
        }
        return monthOptions;
    }

    getScansStatForTable = () => {
        let statData = [];
        if(this.state.fullStatsData[this.state.selectedYear] != undefined && this.state.fullStatsData[this.state.selectedYear][this.state.selectedMonth] != undefined) {
            let yearData = this.state.fullStatsData[this.state.selectedYear];
            let monthData = yearData[this.state.selectedMonth+1]
            console.log(monthData)
                for(let j = 1; j < Object.keys(monthData).length; j++){
                statData.push(
                    {
                        'key': j,
                        'Date': this.getDateAndPlotComponent(this.state.selectedYear, monthMapping[this.state.selectedMonth+1], j),
                        'totalScans': this.getScanCountComponent(monthData[j]),
                        'timeComponent': this.getTimeComponent(monthData[j]),
                        'sizeComponent': this.getSizeComponent(monthData[j]),
                        // 'graphComponent': this.getPlotComponent(j),
                        'scannedAreaComponent': this.getScannedAreaComponent(monthData[j]),
                        'scanSpeedComponent': this.getScanSpeedComponent(monthData[j]),
                        'specimenTypeComponent': this.getSpecimenTypeComponent(monthData[j])
                    }
                )
            }
        }
        return statData;
    }

    getDateAndPlotComponent = (year,month,date) => {
        return <Tooltip title={"Plot Area vs Time"} placement={"right"}>
            <Button onClick={() => this.getPlots(date)}>
                {year + "-" + month + "-" + date}
            </Button>
        </Tooltip>
    }

    getTimeComponent = (monthData) => {
        return <div>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{Math.floor(monthData.mean_time) + " min. " + Math.floor(monthData.mean_time % 60) + " sec."}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{Math.floor(monthData.median_time) + " min. " + Math.floor(monthData.median_time % 60) + " sec."}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{Math.floor(monthData.sum_time) + " min. " + Math.floor(monthData.sum_time % 60) + " sec."}</span>
                </Col>
            </Row>
            <Row>
                <b>{monthData.missing_slide_meta + " missing"}</b>
            </Row>
        </div>
    }

    getSizeComponent = (monthData) => {
        return <div>
            <Row>
                <b>{"Total Size"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_total_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_total_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.mean_total_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_total_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_total_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.median_total_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_total_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_total_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.sum_total_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <b>{"Required Size"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_required_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_required_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.mean_required_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_required_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_required_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.median_required_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_required_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_required_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.sum_required_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <b>{"Debug Size"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_debug_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_debug_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.mean_debug_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_debug_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_debug_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.median_debug_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_debug_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_debug_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.sum_debug_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <b>{monthData.missing_size_meta + " missing"}</b>
            </Row>
        </div>
    }

    getArchivedSizeComponent = (monthData) => {
        return <div>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_archived_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_archived_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.mean_archived_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_archived_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_archived_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.median_archived_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_archived_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_archived_size / 1024 / 1024).toFixed(2) + " MB" : 
                        (monthData.sum_archived_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <b>{monthData.missing_size_meta + " missing"}</b>
            </Row>
        </div>
    }

    getScannedAreaComponent = (monthData) => {
        return <div>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_area.toFixed(2)+" mm2"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_area.toFixed(2)+" mm2"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.sum_area.toFixed(2)}</span>
                </Col>
            </Row>
            <Row>
                <b>{monthData.missing_slide_meta + " missing"}</b>
            </Row>
        </div>
    }

    getScanCountComponent = (monthData) => {
        let scanCountRows = [];
        let keys = Object.keys(monthData.scans);
        for(let i = 0; i < keys.length; i++) {
            scanCountRows.push(
                <Row>
                    <Col span={12}>
                        <span>{keys[i] + ": "}</span>
                    </Col>
                    <Col span={12}>
                        <span>{monthData.scans[keys[i]]}</span>
                    </Col>
                </Row>
            );
        }
        return <div>
            {scanCountRows}
            {/* <Row>
                <b>{monthData.missing_scan_speed + " missing"}</b>
            </Row> */}
        </div>
    }

    getScanSpeedComponent = (monthData) => {
        let scanSpeedRows = [];
        let keys = Object.keys(monthData.scan_speed);
        for(let i = 0; i < keys.length; i++) {
            scanSpeedRows.push(
                <Row>
                    <Col span={12}>
                        <span>{keys[i] + ": "}</span>
                    </Col>
                    <Col span={12}>
                        <span>{monthData.scan_speed[keys[i]]}</span>
                    </Col>
                </Row>
            );
        }
        return <div>
            {scanSpeedRows}
            <Row>
                <b>{monthData.missing_scan_speed + " missing"}</b>
            </Row>
        </div>
    }

    getSpecimenTypeComponent = (monthData) => {
        let scanSpeedRows = [];
        let keys = Object.keys(monthData.specimen_type);
        for(let i = 0; i < keys.length; i++) {
            scanSpeedRows.push(
                <Row>
                    <Col span={12}>
                        <span>{keys[i] + ": "}</span>
                    </Col>
                    <Col span={12}>
                        <span>{monthData.specimen_type[keys[i]]}</span>
                    </Col>
                </Row>
            );
        }
        return <div>
            {scanSpeedRows}
            {/* <Row>
                <b>{monthData.missing_objective_type + " missing"}</b>
            </Row> */}
        </div>
    }

    render() {

        let columns = [
            {
                title: 'Date',
                dataIndex: 'Date',
                key: 'Date',
            },
            {
                title: 'Total Scans',
                dataIndex: 'totalScans',
                key: 'totalScans',
            },
            {
                title: 'Time',
                dataIndex: 'timeComponent',
                key: 'timeComponent',
            },
            {
                title: 'Size',
                dataIndex: 'sizeComponent',
                key: 'sizeComponent',
            },
            {
                title: 'Scanned Area',
                dataIndex: 'scannedAreaComponent',
                key: 'scannedAreaComponent',
            },
            {
                title: 'Scan Speed',
                dataIndex: 'scanSpeedComponent',
                key: 'scanSpeedComponent',
            },
            {
                title: 'Specimen Type',
                dataIndex: 'specimenTypeComponent',
                key: 'specimenTypeComponent',
            },
            // {
            //     title: 'Time vs Area Graph',
            //     dataIndex: 'graphComponent',
            //     key: 'graphComponent',
            // },
        ];

        let scansStat = this.getScansStatForTable();

        return (
            <div>
                <Spin spinning={this.state.isFetching}>
                    <div>
                        <Row>
                            <Col span={24} offset={0} className="all-slides">
                                <div className="heading-style main-heading-style">
                                    <b>Stats Dashboard</b>
                                </div>
                                <div>
                                    <br />
                                    <Row>
                                        <Col span={2} style={{padding: "5px 0px 0px 20px"}}>
                                            <b>{"Select Year: "}</b>
                                        </Col>
                                        <Col span={5}>
                                            <Select style={{width: 75}}
                                                value={this.state.selectedYear}
                                                placeholder="Select Year"
                                                onChange={this.handleChangeYear}
                                            >
                                                {this.getYearOptions()}
                                            </Select>
                                        </Col>
                                        <Col span={2} style={{padding: "5px 0px 0px 20px"}}>
                                            <b>{"Select Month: "}</b>
                                        </Col>
                                        <Col span={5}>
                                            <Select style={{width: 75}}
                                                value={monthMapping[this.state.selectedMonth+1]}
                                                placeholder="Select Month"
                                                onChange={this.handleChangeMonth}
                                            >
                                                {this.getMonthOptions()}
                                            </Select>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Table
                                        dataSource={scansStat}
                                        columns={columns}
                                        pagination={false}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
};

export default connect(mapStateToProps)(StatsDashboard);